<script>
import MethodButtonBase from './MethodButtonBase';
import EparakstsMarkIcon from '../../assets/svg/e-paraksts-mark.svg';
export default {
  name: 'EparakstsSmartCardButton',
  components: {
    MethodButtonBase,
    EparakstsMarkIcon,
  },
}
</script>

<template>
  <MethodButtonBase>
    <template v-slot:slot1>
      <EparakstsMarkIcon :class="$style.icon" />
    </template>
    <template v-slot:slot2>
      {{ $t('eparaksts-smart-card') }}
    </template>
  </MethodButtonBase>
</template>

<style lang="scss" module>
.icon {
  display: block;
  width: 28px;
  height: auto;
  margin-right: 8px;
}
</style>
